module.exports = __webpack_public_path__ + "img/enet.3a091453.jpg";